<template lang="pug">
.vacancy-footer.col
  .vacancy-footer__text
    h1.vacancy-footer__title
      | Хотите стать частью
      br
      | команды?
    h1.vacancy-footer__title
      | Отправляйте заявку
      br
      | и мы пришлем вам
      br
      | тестовое задание
    p.vacancy-footer__subtitle.vacancy-footer__subtitle_desktop
      | Вдумчиво. Дорого. На совесть.
      br
      a(href="tel:+7 (800) 200 38 01").vacancy-footer__link +7 800 200 38 01
      br
      a(href="mailto:order@nekidaem.ru").vacancy-footer__link order@nekidaem.ru
      br
      | © 2010-{{ dt }}
    .social-media__wrapper
      SocialLinksView
  Form(:value="formValue" :vacancy="vacancyName").vacancy-form
  p.vacancy-footer__subtitle.vacancy-footer__subtitle_mobile
    | Вдумчиво. Дорого. На совесть.
    br
    a(href="tel:+7 (800) 200 38 01").vacancy-footer__link +7 800 200 38 01
    br
    a(href="mailto:order@nekidaem.ru").vacancy-footer__link order@nekidaem.ru
    br
    | © 2010-{{ dt }}
</template>

<script setup>
const props = defineProps({
  formValue: {
    type: Object,
    required: true
  },
  vacancyName: {
    type: String
  }
})

const dt = new Date().getFullYear()
</script>

<style lang="scss" scoped>
.vacancy-footer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 100px 0 80px 0;

  @media (min-width: $breakpoint-small) {
    justify-content: space-between;
  }

  @media (min-width: $breakpoint-xlarge) {
    padding: 280px 0 80px 0;
  }

  &__text {
    margin-bottom: 40px;

    @media (min-width: $breakpoint-small) {
      margin-bottom: 0;
    }
  }

  &__title {
    margin-bottom: 48px;
  }

  &__subtitle {
    color: $primary;
    font-weight: bold;

    &_mobile {
      margin-top: 80px;
    }

    &_desktop {
      display: none;
    }

    @media (min-width: $breakpoint-medium) {

      &_desktop {
        display: block;
      }

      &_mobile {
        display: none;
      }
    }
  }

  &__link {
    color: $primary;
    text-decoration: none;
  }
}

.vacancy-form {
  width: 100%;
  margin-top: 32px;

  @media (min-width: $breakpoint-medium) {
    max-width: 335px;
    width: 100%;
    margin-top: 0;
  }
}

.social-media {
  &__wrapper {
    padding-top: 20px;
  }
}
</style>
